import { createContext, useContext } from 'react';

export const CategoriesContext = createContext({});
export const useCategoriesContext = () => useContext(CategoriesContext);

export const CategoryContext = createContext({});
export const useCategoryContext = () => useContext(CategoryContext);
